import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import FounderSection from './components/FounderSection';

import MethodologySection from './components/MethodologySection';

import WhyChooseSection from './components/WhyChooseSection';
import PartnershipsSection from './components/PartnershipsSection';

const AboutExpertiseTrustBuilding = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>About Northstar Analytics - Data Strategy Expertise & Trust Building</title>
        <meta 
          name="description" 
          content="Meet the Northstar Analytics team - your trusted data strategy guides. Learn about our founder, expert team, proven methodologies, and successful client transformations. Discover why organizations choose us for strategic data leadership." 
        />
        <meta name="keywords" content="data strategy consultancy, data transformation experts, GDPR compliance, data governance, analytics team, data maturity assessment, Dublin Ireland" />
        <meta property="og:title" content="About Northstar Analytics - Data Strategy Expertise & Trust Building" />
        <meta property="og:description" content="Meet the Northstar Analytics team - your trusted data strategy guides with proven methodologies and successful client transformations." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/about-expertise-trust-building" />
      </Helmet>
      <Header />
      <main className="pt-16 lg:pt-20">
        {/* Hero Section - North Star metaphor and founder introduction */}
        <HeroSection />

        {/* Founder Section - Mark McEvoy's story and philosophy */}
        <FounderSection />

        {/* Methodology Section - Proprietary frameworks (COMPASS, ELEVATE, NAVIGATE) */}
        <MethodologySection />

        {/* Why Choose Section - Differentiators and trust indicators */}
        <WhyChooseSection />

        {/* Partnerships Section - Technology and industry alliances */}
        <PartnershipsSection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutExpertiseTrustBuilding;